<div class="card">
    <div class="card-body">
        <h5 class="card-title main-blue">
            {{ "PurchaseDetails.purchase" | translate }}
        </h5>
        <div class="card-text">
            <div class="row">
                <div class="col-sm-2 bolded">
                    {{ "PurchaseDetails.campType" | translate }}
                </div>
                <div class="col-sm-10">{{ campTypeLabel }}</div>
            </div>
            <div class="row">
                <div class="col-sm-2 bolded">
                    {{ "PurchaseDetails.purchaseNumber" | translate }}
                </div>
                <div class="col-sm-10">{{ purchase.purchaseSetNumber }}</div>
            </div>

            @if (!purchase.originalPurchaseDate) {
                <div class="row">
                    <div class="col-sm-2 bolded">
                        {{ "PurchaseDetails.date" | translate }}
                    </div>
                    <div class="col-sm-10">{{ purchase.date | bcDate }}</div>
                </div>
            }

            @if (purchase.originalPurchaseDate) {
                <div class="row">
                    <div class="col-sm-2 bolded">
                        {{ "PurchaseDetails.originalPurchaseDate" | translate }}
                    </div>
                    <div class="col-sm-10">
                        {{ purchase.originalPurchaseDate | bcDate }}
                    </div>
                </div>
            }
            @if (purchase.originalPurchaseDate) {
                <div class="row">
                    <div class="col-sm-2 bolded">
                        {{ "PurchaseDetails.dateOfLastRefund" | translate }}
                    </div>
                    <div class="col-sm-10">{{ purchase.date | bcDate }}</div>
                </div>
            }

            <div class="row">
                <div class="col-sm-2 bolded">
                    {{ "PurchaseDetails.status" | translate }}
                </div>
                <div class="col-sm-10" hznTestId="purchase-info-status">
                    {{ purchase.status }}
                    @if (purchase.isModification) {
                        <span class="ml-1">{{
                            "PurchaseDetails.partiallyRefunded" | translate
                        }}</span>
                    }
                </div>
            </div>
            @if (purchase.refundedBy) {
                <div class="row">
                    <div class="col-sm-2 bolded">
                        {{ "PurchaseDetails.refundedBy" | translate }}
                    </div>
                    <div class="col-sm-10">{{ purchase.refundedBy }}</div>
                </div>
            }
            @if (purchase.refundDate) {
                <div class="row">
                    <div class="col-sm-2 bolded">
                        {{ "PurchaseDetails.refundDate" | translate }}
                    </div>
                    <div class="col-sm-10">
                        {{ purchase.refundDate | bcDate }}
                    </div>
                </div>
            }

            @if (!isOfficePurchase) {
                <div class="row">
                    <div class="col-sm-2 bolded">
                        {{ "PurchaseDetails.buyer" | translate }}
                    </div>
                    <div class="col-sm-10">
                        {{ purchase.finalizedBy }} ({{
                            purchase.finalizedByMemberId
                        }})
                    </div>
                </div>
            }
            @if (isOfficePurchase) {
                <div class="row">
                    <div class="col-sm-2 bolded">
                        {{ "PurchaseDetails.buyer" | translate }}
                    </div>
                    <div class="col-sm-10">
                        {{ purchase.officePurchaseMemberName }} ({{
                            purchase.finalizedByMemberId
                        }})
                    </div>
                </div>
            }

            <div class="row">
                <div class="col-sm-2 bolded">
                    {{ "PurchaseDetails.payer" | translate }}
                </div>
                <div class="col-sm-10">
                    {{ purchase.payerMembership }}
                    @if (isBuyerInOtherMembershipThanPayer) {
                        <span
                            class="main-red size-10 bolded"
                            translate="PurchaseDetails.buyerPayerDifferentMembershipWarning"
                            [translateParams]="{
                                buyerMembership: purchase.finalizedByMembership,
                            }"
                            ></span
                        >
                    }
                </div>
            </div>
            @if (isOfficePurchase) {
                <div class="row">
                    <div class="col-sm-2 bolded">
                        {{ "PurchaseDetails.finalizedByEmployee" | translate }}
                    </div>
                    <div class="col-sm-10">
                        {{ purchase.finalizedByEmployee }}
                    </div>
                </div>
            }
        </div>
    </div>
</div>
